import React from 'react';
import cx from 'classnames';

import styles from './styles.module.scss';

export interface ActionBarProps {
    query: string;
    onQueryChange: React.Dispatch<React.SetStateAction<string>>;
    onSubmit: () => void;
    inputPlaceholder?: string;
    disabled?: boolean;
}

const ActionBar: React.FC<ActionBarProps> = ({
    query,
    onQueryChange,
    onSubmit,
    inputPlaceholder = 'Ask anything about this deal...',
    disabled = false,
}) => {
    const canSubmit = query.trim().length > 0;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (canSubmit) {
                onSubmit();
            }
        }
    };

    return (
        <div className={cx(styles.footer, { [styles.disabled]: disabled })}>
            <div className={styles.inputBar}>
                <input
                    type="text"
                    className={styles.input}
                    placeholder={inputPlaceholder}
                    value={query}
                    onChange={(e) => onQueryChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                    disabled={disabled}
                />
                <button
                    type="button"
                    className={cx(styles.submitButton, (canSubmit && !disabled) ? styles.submitActive : styles.submitMuted)}
                    disabled={!canSubmit || disabled}
                    onClick={() => (canSubmit && !disabled) && onSubmit()}
                >
                    <i className="paperflite-right-arrow" />
                </button>
            </div>
        </div>
    );
};

export default ActionBar;
